import { FC, useState } from "react";
import { TypedFilter } from "odata-query";
import { makeStyles } from "tss-react/mui";
import { MiList } from "@miplatform/components";
import { CONFIG_PAGES } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { IUserListItemResponse } from "@miplatform/types";
import { Box } from "@mui/system";
import { CONFIG_PATHS } from "../../../../../routes/config/constants/configPaths";
import { ConfigUserProfileListCard } from "../../../Users/components/ConfigUserProfileListCard";
import { ConfigAccordionHeader } from "../../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { DepartmentDetailsConfigViewProps } from "../../ConfigDepartments.types";

export const DepartmentConfigUsersListTabView: FC<
  DepartmentDetailsConfigViewProps
> = ({ form: { getValues }, extraTabProps: { departmentId } }) => {
  const { navigate } = useRouter();
  const { users = [] } = getValues();
  const { classes } = useStyles();

  const [filter] = useState<TypedFilter<IUserListItemResponse>>({});

  const navigateToUserDetails = (userId: string) => {
    if (!departmentId) {
      return;
    }

    navigate(
      `${
        CONFIG_PATHS[CONFIG_PAGES.DEPARTMENTS]
      }/${departmentId}/users/${userId}`
    );
  };

  return (
    <ConfigAccordionHeader title="Users List">
      <Box className={classes.container}>
        <MiList
          viewType="card"
          data={users}
          CardComponent={ConfigUserProfileListCard}
          cardProps={{
            navigateToUserDetails,
            hideActions: true,
          }}
          entityName="Users"
          emptyListProps={{
            text: "No Users found",
          }}
          refresh={filter}
        />
      </Box>
    </ConfigAccordionHeader>
  );
};

const useStyles = makeStyles()(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "calc(100vh - 310px)",
  },
}));
